@if (domainDetailsAsync$ | async; as domain) {
    <mat-card class="m-3">
        <mat-card-header>
            <mat-card-title class="fw-bold">
                {{ domain.name }}
                <span class="fw-normal">({{ domain.state }})</span>
            </mat-card-title>
            <mat-card-subtitle class="text-secondary">
                {{ domain.id }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="row mt-4">
                <div class="col-4">
                    <p><strong>Platform:</strong> {{ domain.platform }}</p>
                    <p><strong>Unit:</strong> {{ domain.unit }}</p>
                    <p><strong>Capability:</strong> {{ domain.capability }}</p>
                    <p><strong>SubGroup:</strong> {{ domain.subGroup }}</p>
                </div>
                <div class="col-4">
                    <p><strong>User groups:</strong></p>
                    @if (domain.roles) {
                        <ul>
                            @for (role of getRoleNames(domain.roles); track role) {
                                <li>
                                    <a
                                        [href]="
                                            'https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/' +
                                            domain.roles[role].groupId
                                        "
                                        target="_blank"
                                    >
                                        {{ role }}
                                    </a>
                                </li>
                            }
                        </ul>
                    }
                    <p class="mt-2"><strong>Your roles:</strong> {{ domain.userRoles }}</p>
                </div>
                <div class="col-4">
                    <p><strong>Confidentiality:</strong> {{ domain.confidentiality }}</p>
                    <p>
                        <strong>Metadata location: </strong>
                        <a [href]="domain.azureDataLakeUri" target="_blank">Folder</a>
                    </p>
                </div>
            </div>
            <mat-divider class="mb-3"></mat-divider>
            <app-business-domain-owners [businessDomainId]="domain.id" />
        </mat-card-content>
    </mat-card>
}
